import api from "../interceptor"



const url =  "/log-web"



export const PageViewAPI =  {

 createUserView: async ()=>{
      return  await api({
            method:"POST",
            url:`${url}/visit`
        })
    }
}